import { ResponsiveFunnel } from '@nivo/funnel'
import { DashboardStep } from './dashboard.types'

const fallbackColors = ['#0D7D49', '#0F9A58', '#12B76A', '#4DDC8A', '#7EEBAA', '#ACF5C8']

const DashboardFunnel = ({ steps, total }: { steps: DashboardStep[]; total: number }) => {
    const chartData = steps.map((step, index) => ({
        id: step.id,
        label: step.label,
        value: step.count === 0 ? 0.01 : step.count,
        color: /^#[0-9a-f]{6}$/i.test(step.color) ? step.color : fallbackColors[index % fallbackColors.length]
    }))

    return (
        <div>
            <div className='h-[280px] sm:h-[320px]' aria-label='Funil de negócios por etapa'>
                <ResponsiveFunnel
                    data={chartData}
                    margin={{ top: 24, right: 20, bottom: 24, left: 20 }}
                    direction='horizontal'
                    interpolation='smooth'
                    shapeBlending={0.45}
                    spacing={3}
                    colors={chartData.map(item => item.color)}
                    borderWidth={2}
                    borderColor='#ffffff'
                    borderOpacity={0.8}
                    enableBeforeSeparators={false}
                    enableAfterSeparators={false}
                    labelColor='#ffffff'
                    valueFormat={value => (value < 1 ? '0' : Math.round(value).toLocaleString('pt-BR'))}
                    currentPartSizeExtension={6}
                    currentBorderWidth={3}
                    motionConfig='gentle'
                    role='img'
                    ariaLabel='Distribuição dos negócios do produto padrão pelas etapas do pipeline'
                    theme={{
                        labels: {
                            text: {
                                fontSize: 18,
                                fontWeight: 700,
                                fontFamily: 'Poppins, sans-serif'
                            }
                        },
                        tooltip: {
                            container: {
                                borderRadius: '10px',
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: '12px'
                            }
                        }
                    }}
                />
            </div>

            <div className='grid grid-cols-1 gap-2 border-t border-gray-100 pt-4 dark:border-gray-800 sm:grid-cols-2 xl:grid-cols-3'>
                {steps.map((step, index) => {
                    const percentage = total > 0 ? Math.round((step.count / total) * 100) : 0
                    const color = /^#[0-9a-f]{6}$/i.test(step.color)
                        ? step.color
                        : fallbackColors[index % fallbackColors.length]

                    return (
                        <div key={step.id} className='flex min-w-0 items-center justify-between gap-3 rounded-lg px-2 py-1.5'>
                            <div className='flex min-w-0 items-center gap-2'>
                                <span className='h-2.5 w-2.5 shrink-0 rounded-full' style={{ backgroundColor: color }} />
                                <span className='truncate text-xs font-medium text-gray-600 dark:text-gray-300'>{step.label}</span>
                            </div>
                            <span className='shrink-0 text-xs font-semibold text-gray-800 dark:text-gray-100'>
                                {step.count} <span className='font-normal text-gray-400'>· {percentage}%</span>
                            </span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default DashboardFunnel
